<template>
  <span @click="$emit('click')">
    <font-awesome-icon
      :class="{ 'star-selected': isFollowed, pointer: isFollowed || !isFollowed }"
      :icon="isFollowed ? ['fas', 'star'] : ['far', 'star']"
    />
  </span>
</template>
<script>
export default {
  name: 'followed-icon',
  props: {
    isFollowed: {},
  },
}
</script>
<style lang="scss" scoped>
.star-selected {
  color: #e2b813;
}
</style>
